import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import './PackingListForShipment.scss';
import { generatePackingListPdf } from './PackingListPDF';
import { TPackingListPdfData } from '../../types/shipment.type';

const PackingListForShipment: React.FC = () => {
  const location = useLocation();
  const packingListData = (location.state as { packingListData?: TPackingListPdfData })?.packingListData;

  if (!packingListData) {
    return <div>Data not available or still loading.</div>; // Fallback UI if packingListData is not present
  }

  // Destructuring packingListData for cleaner access
  const { shipment_id, created_at, skuTotal, unitTotal, shipmentItems, packingList, ship_from, ship_to } = packingListData;

  const downloadPDF = async () => {
    const pdfBytes = await generatePackingListPdf(packingListData);
const blob = new Blob([pdfBytes.buffer as ArrayBuffer], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `PackingList_${shipment_id}.pdf`;
    link.click();
  };

  return (
    <Box className="packing-list">
      <Box id="pdf-content">
        <Box className="header-section">
          <Box className="logo-name-container">
            <Box className="logo">
              {packingList.logo_url ? (
                <img className="logo-image" src={packingList.logo_url} alt="Logo" />
              ) : (
                <Typography>Image</Typography>
              )}
            </Box>
            <Typography className="account-name">{packingList.name}</Typography>
          </Box>
          <Typography className="packing-list-title">Packing List</Typography>

          <Box className="po-number">
            <Typography>Shipment ID: {shipment_id}</Typography>
            <Typography>Date: {created_at ? new Date(created_at).toLocaleDateString() : ''}</Typography>
            <Typography>SKU Total: {skuTotal}</Typography>
            <Typography>Unit Total: {unitTotal}</Typography>
          </Box>
        </Box>

        <Box className="shipment-details">
          <Box className="ship-from">
            <Typography variant="h6">Ship From</Typography>
            <Typography>{ship_from?.name}</Typography>
            <Typography>{ship_from?.address}</Typography>
            <Typography>
              {ship_from?.city}
              {ship_from?.city && ship_from?.state ? ', ' : ''}
              {ship_from?.state}
            </Typography>
            <Typography>
              {ship_from?.country}
              {ship_from?.country && ship_from?.zip_code ? ', ' : ''}
              {ship_from?.zip_code}
            </Typography>
          </Box>
          <Box className="ship-to">
            <Typography variant="h6">Ship To</Typography>
            <Typography>{ship_to?.name}</Typography>
            <Typography>{ship_to?.address}</Typography>
            <Typography>
              {ship_to?.city}
              {ship_to?.city && ship_to?.state ? ', ' : ''}
              {ship_to?.state}
            </Typography>
            <Typography>
              {ship_to?.country}
              {ship_to?.country && ship_to?.zip_code ? ', ' : ''}
              {ship_to?.zip_code}
            </Typography>
          </Box>
        </Box>

        <Box className="table-section">
          <Table aria-label="packing list table">
            <TableHead>
              <TableRow>
                <TableCell>Item</TableCell>
                <TableCell>SKU</TableCell>
                <TableCell>FNSKU</TableCell>
                <TableCell>ASIN</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Quantity Shipped</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {shipmentItems.map((shipmentItem, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{shipmentItem.sku}</TableCell>
                  <TableCell>{shipmentItem.fnsku}</TableCell>
                  <TableCell>{shipmentItem.asin}</TableCell>
                  <TableCell>{shipmentItem.description}</TableCell>
                  <TableCell>{shipmentItem.quantity_shipped}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>

        <Box className="signature-section" sx={{ marginTop: 2 }}>
          {packingList.signature_url ? (
            <img src={packingList.signature_url} alt="Signature" />
          ) : (
            <Typography>Signature</Typography>
          )}
        </Box>
      </Box>

      <Button
        variant="contained"
        color="primary"
        onClick={downloadPDF}
        sx={{ mt: 2 }}
      >
        Download PDF
      </Button>
    </Box>
  );
};

export default PackingListForShipment;
